import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router";
import GuestRoute from "helpers/authentication/guestRoute";
import AuthRoute from "helpers/authentication/authRoute";
import Layout from "./components/Layout/Layout";
import Dashboard from "views/dashboard";
import NotFound from "views/NotFound";
import Login from "views/login";
import Logout from "views/Logout";
import { getAllSettings, getCurrentUser } from "store/actions";
import Loader from "./components/shared/Loader";
import Settings from "views/Settings";
import About from "views/about/about";
import ContactUs from "views/ContactUs";
import Socials from "views/socials";
import AddSocial from "views/socials/AddSocial";
import EditSocial from "views/socials/EditSocial";
import ShowContact from "views/ContactUs/ShowContact";
import SocialTypes from "views/socialTypes";
import AddSocialTypes from "views/socialTypes/AddSocial";
import EditSocialType from "views/socialTypes/EditSocial";
import Hero from "views/home/hero";
import ProjectsInfo from "views/home/projects";
import Projects from "views/projects";
import AddProjects from "views/projects/Add";
import EditProjects from "views/projects/Edit";
import Statistics from "views/home/statistics";
import Reviews from "views/home/reviews";
import Faqs from "views/faqs";
import Subscribers from "views/subscribers";
import OtherProjects from "views/otherProjects";
import CeoMessage from "views/about/CeoMessage";
import DistinguishUs from "views/about/distinguishUs";
import AddBlog from "views/blogs/AddBlog";
import ShowBlog from "views/blogs/ShowBlog";
import AddBlogCategory from "views/blogsCategories/AddBlogCategory";
import EditBlogCategory from "views/blogsCategories/EditBlogCategory";
import Blogs from "views/blogs/Index";
import BlogCategories from "views/blogsCategories/Index";
import EditBlog from "views/blogs/EditBlog";
import BlogsHeading from "views/home/blogs";
import Project from "views/about/project";
import TeamMembers from "views/about/TeamMembers";
import Categories from "views/categories";
import AddCategories from "views/categories/Add";
import EditCategories from "views/categories/Edit";

const App = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  //selectors
  const { isLoggedIn } = useSelector((state) => state?.authentication);
  const { settings } = useSelector((state) => state.settings);
  const logo = settings?.appLogo;

  useEffect(() => {
    dispatch(getAllSettings());
  }, [dispatch]);

  useEffect(() => {
    if (token) dispatch(getCurrentUser());
  }, [token, dispatch]);

  const RenderApp = () => {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout logo={logo} />}>
              <Route
                path="/"
                element={
                  <AuthRoute>
                    <Dashboard />
                  </AuthRoute>
                }
              />

              {/* home  */}
              <Route
                path="/home/hero"
                element={
                  <AuthRoute>
                    <Hero />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/statistics"
                element={
                  <AuthRoute>
                    <Statistics />
                  </AuthRoute>
                }
              />

              <Route
                path="home/blogs"
                element={
                  <AuthRoute>
                    <BlogsHeading />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/projects"
                element={
                  <AuthRoute>
                    <ProjectsInfo />
                  </AuthRoute>
                }
              />
              {/* other projects  */}
              <Route
                path="/otherprojects"
                element={
                  <AuthRoute>
                    <OtherProjects />
                  </AuthRoute>
                }
              />
              <Route
                path="home/reviews"
                element={
                  <AuthRoute>
                    <Reviews />
                  </AuthRoute>
                }
              />

              {/* about  */}
              <Route
                path="/aboutUs/about"
                element={
                  <AuthRoute>
                    <About />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/distinguishUs"
                element={
                  <AuthRoute>
                    <DistinguishUs />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/ceoMessage"
                element={
                  <AuthRoute>
                    <CeoMessage />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/project"
                element={
                  <AuthRoute>
                    <Project />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/teamMembers"
                element={
                  <AuthRoute>
                    <TeamMembers />
                  </AuthRoute>
                }
              />

              {/* Projects */}
              <Route
                path="/projects"
                element={
                  <AuthRoute>
                    <Projects />
                  </AuthRoute>
                }
              />
              <Route
                path="/projects/add"
                element={
                  <AuthRoute>
                    <AddProjects />
                  </AuthRoute>
                }
              />

              <Route
                path="/projects/:id"
                element={
                  <AuthRoute>
                    <EditProjects />
                  </AuthRoute>
                }
              />
              {/* Categories */}
              <Route
                path="/categories"
                element={
                  <AuthRoute>
                    <Categories />
                  </AuthRoute>
                }
              />
              <Route
                path="/categories/add"
                element={
                  <AuthRoute>
                    <AddCategories />
                  </AuthRoute>
                }
              />

              <Route
                path="/categories/:id"
                element={
                  <AuthRoute>
                    <EditCategories />
                  </AuthRoute>
                }
              />
              {/* blogs */}
              <Route
                path="/blogs"
                element={
                  <AuthRoute>
                    <Blogs />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/addblog"
                element={
                  <AuthRoute>
                    <AddBlog />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/:id"
                element={
                  <AuthRoute>
                    <EditBlog />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/show/:id"
                element={
                  <AuthRoute>
                    <ShowBlog />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/categories"
                element={
                  <AuthRoute>
                    <BlogCategories />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/categories/addcategory"
                element={
                  <AuthRoute>
                    <AddBlogCategory />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/categories/:id"
                element={
                  <AuthRoute>
                    <EditBlogCategory />
                  </AuthRoute>
                }
              />
              {/* faqs */}
              <Route
                path="/faqs"
                element={
                  <AuthRoute>
                    <Faqs />
                  </AuthRoute>
                }
              />
              {/* contact */}
              <Route
                path="/contactUs"
                element={
                  <AuthRoute>
                    <ContactUs />
                  </AuthRoute>
                }
              />
              <Route
                path="/contactUs/show/:id"
                element={
                  <AuthRoute>
                    <ShowContact />
                  </AuthRoute>
                }
              />
              {/* socials */}
              <Route
                path="/socials"
                element={
                  <AuthRoute>
                    <Socials />
                  </AuthRoute>
                }
              />

              <Route
                path="/socials/addSocial"
                element={
                  <AuthRoute>
                    <AddSocial />
                  </AuthRoute>
                }
              />

              <Route
                path="/socials/:id"
                element={
                  <AuthRoute>
                    <EditSocial />
                  </AuthRoute>
                }
              />
              {/* socialTypes */}
              <Route
                path="/socialTypes"
                element={
                  <AuthRoute>
                    <SocialTypes />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialTypes/addSocial"
                element={
                  <AuthRoute>
                    <AddSocialTypes />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialTypes/:id"
                element={
                  <AuthRoute>
                    <EditSocialType />
                  </AuthRoute>
                }
              />
              {/* subscribers */}
              <Route
                path="/subscribers"
                element={
                  <AuthRoute>
                    <Subscribers />
                  </AuthRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <AuthRoute>
                    <Settings />
                  </AuthRoute>
                }
              />

              <Route
                path="*"
                element={
                  <AuthRoute>
                    <NotFound />
                  </AuthRoute>
                }
              />
            </Route>

            {/*Auth Routes */}
            <Route
              path="/logout"
              element={
                <AuthRoute>
                  <Logout />
                </AuthRoute>
              }
            />
            <Route
              path="/login"
              element={
                <GuestRoute>
                  <Login logo={logo} />
                </GuestRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </Suspense>
    );
  };

  if (!token) return RenderApp();
  if (isLoggedIn !== null) return RenderApp();
  return <Loader />;
};

export default App;
